import { Component, OnInit, Input } from '@angular/core';
import { FormVariable } from 'app/common/model/form-variable';

@Component({
  selector: 'mc-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss']
})
export class TimeComponent implements OnInit {

  @Input() formVariable: FormVariable;

  constructor() { }

  ngOnInit() {
  }

}
